import { useEffect, useState } from "react";
import { Grid, SvgIcon, Typography, Divider } from "@mui/material";
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { curve, curveEnd, ReportLibraryIcon } from "../../../Assets/Svg/Svg";
import { BorderLinearProgress, menuData } from "../../Common/MuiStyles/MuiStyles";
import "../../../Assets/Styles/Containers/_sidemenu.scss";
import Avatar from "@mui/material/Avatar";
import { isHTCompanyKey } from "../../Utils/services";
import { portalUrl } from "../../Config/Api-constants";
import { MOVE_COPY_TOAST_NAV_SOURCE } from "../../Config/App-constants";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import CallMissedOutgoingIcon from "@mui/icons-material/CallMissedOutgoing";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  allInspectorFlagging,
  categoryPercentCalculate,
  categoryPercentCalculateNarrative,
  checkLineComplete,
  cleanPayloadOnCategoryLevel,
  cleanPayloadOnLineLevel,
  getNonNarrativeTemplatesGuid,
  totalLineCountCalulate,
} from "../../Helpers/HelperFunctions";
import { editCategory, editLine, scrollTop, reorderCategory, reorderLines, clearActiveLine, activateLines, getInspectionData, getInspectionDataWithOutLoader, getTemplateListCall } from "../../Redux/Actions/CommonActions";
import { ApiCallDuplicateCategory, ApiCallDuplicateLine, UpdateTemplateDataSpecific, categoryLineRelation, getDefaultCategories, getDefaultLines } from "../../Helpers/ApiCall";
import { Base64 } from "js-base64";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { GetUTCTime } from "../../Helpers/GetUTCTime";
import DeleteIcon from "@mui/icons-material/Delete";
import toast from "react-hot-toast";
import DeleteConfirmationDialog from "../../Common/Alert/DeleteConfirmationDialog";
import { v4 as uuidv4 } from "uuid";
import AddLineModal from "../Lines/AddLineModal";
import CreateNewLineModal from "../Lines/CreateNewLineModal";
import AddOptionalNdStandardLineModal from "../Lines/AddOptionalNdStandardLineModal";
import AddCategoryModal from "../Category/AddCategoryModal";
import CreateNewCategoryModal from "../Category/CreateNewCategoryModal";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { GrDuplicate } from "react-icons/gr";
import Skeleton from "@mui/material/Skeleton";

const SideMenu = ({ zeroState }) => {
  const [active, setActive] = useState("");
  const [activeTemplate, setActiveTemplate] = useState("");
  const [activeLine, setActiveLine] = useState("");
  const [disableCatActive, setDisableCatActive] = useState(false);
  const [inspectionResponse, setInspectionResponse] = useState();
  const [showStaticBackground, setShowStaticBackground] = useState(false);
  const [disableSwitch, setDisableSwitch] = useState(false);
  const [staticBG, setStaticBG] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isInspectionDetailsHovered, setIsInspectionDetailsHovered] = useState(false);
  const [isCategoryHovered, setIsCategoryHovered] = useState(false);
  const [isHoveredLineUuid, setIsHoveredLineUuid] = useState("");
  const [isHoveredInspectionDetailsLineUuid, setIsHoveredInspectionDetailsLineUuid] = useState("");
  const [isHoveredCategoryUuid, setIsHoveredCategoryUuid] = useState("");
  const [deleteLineModal, setShowDeleteLineModal] = useState(false);
  const [activeDeleteLine, setActiveDeleteLine] = useState("");
  const [activeDeleteAndDuplicateTemplate, setActiveDeleteAndDuplicateTemplate] = useState("");
  const [activeDeleteAndDuplicateCategory, setActiveDeleteAndDuplicateCategory] = useState("");
  const [deleteCategoryModal, setDeleteCategoryModal] = useState(false);
  const [deleteCategoryToast, setDeleteCategoryToast] = useState(false);
  const [deleteLineToast, setDeleteLineToast] = useState(false);
  const [activeDeleteCategory, setActiveDeleteCategory] = useState("");
  const [activeDeleteCategoryIdx, setActiveDeleteCategoryIdx] = useState("");
  const [activeLineIdx, setActiveLineIdx] = useState("");
  const [showLineModal, setShowLineModal] = useState(false);
  const [showInspLineModal, setShowInspLineModal] = useState(false);
  const [showCreateNewLineModal, setShowCreateNewLineModal] = useState(false);
  const [selectedLines, setSelectedLines] = useState([]);
  const [newLineList, setNewLineList] = useState([]);
  const [categoryData, setCategoryData] = useState();
  const [newCategoryList, setNewCategoryList] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);
  const [templateData, setTemplateData] = useState([]);
  const [tempDuplicateCategoryIdx, setTempDuplicateCategoryIdx] = useState("");
  const [tempDuplicateLineIdx, setTempDuplicateLineIdx] = useState("");
  const [duplicatedCategoryTemplateIdx, setDuplicatedCategoryTemplateIdx] = useState("");
  const [duplicateCategoryIdx, setDuplicateCategoryIdx] = useState("");
  const [duplicateCategoryIconClicked, setDuplicateCategoryIconClicked] = useState(false);
  const [duplicateLineIconClicked, setDuplicateLineIconClicked] = useState(false);
  const [categoryHighlighted, setCategoryHighlighted] = useState(false);
  const [lineHighlighted, setLineHighlighted] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [selectedDropdownTemplateGuid, setSelectedDropdownTemplateGuid] = useState();
  const [clickedFrom, setClickedFrom] = useState(false)

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state: urlState } = useLocation();
  let templateId = urlState?.template_id;
  let categoryId = urlState?.category_id;
  const storeData = useSelector((state) => state.CommonReducer);
  const assignColorList = storeData?.inspectionData?.data?.inspectorFlagList?.filter((item) => item.is_deleted !== 1) || [];
  const handleDuplicateLine = async (templateId, categoryUuid, line, e, lineIdx, categoryIdx) => {
    let duplicateTemplateData = storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId);
    let CategoryData = duplicateTemplateData?.categories?.find((itm) => itm.id === categoryId);
    let objectToAdd = {
      uuid: uuidv4(),
      prompt: "",
      showLineEmpty: true,
      comments: [],
      optional: 0,
      created_at: GetUTCTime(),
      is_deleted: 0,
      updated_at: "",
      defaultRating_id: 1,
      default_location: null,
      line_input_controls: [],
    };
    CategoryData?.lines.splice(lineIdx + 1, 0, objectToAdd);
    const formData = {
      guid: sessionStorage.getItem("guid"),
      inspection_id: storeData.inspectionData?.data?.inspection_id,
      template_id: templateId,
      category_uuid: categoryUuid,
      line_uuid: line?.uuid,
      inspection_guid: storeData.inspectionData?.data?.guid,
    };
    setLineHighlighted(true);
    setTempDuplicateLineIdx(lineIdx + 1);
    setDuplicateLineIconClicked(true);
    setDuplicateCategoryIdx(categoryIdx);
    await ApiCallDuplicateLine(dispatch, formData);
    setTimeout(() => {
      setDuplicateLineIconClicked(false);
      setLineHighlighted(false);
    }, 1000);
  };

  const handleDuplicateCategory = async (templateId, category, e, categoryIdx, templateIdx) => {
    let duplicateTemplateData = storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId);
    const objectToAdd = {
      id: category?.id,
      uuid: uuidv4(),
      template_id: templateId,
      showEmpty: true,
      prompt: null,
      introductory_text: null,
      lines: null,
      parent_uuid: null,
      order: 0,
      is_deleted: 0,
      optional: 0,
      is_inspection_details: 0,
      updated_at: GetUTCTime(),
      is_selected: false,
    };
    duplicateTemplateData?.categories.splice(categoryIdx + 1, 0, objectToAdd);
    const formData = {
      guid: sessionStorage.getItem("guid"),
      inspection_id: storeData.inspectionData?.data?.inspection_id,
      template_id: templateId,
      category_uuid: category.uuid,
      inspection_guid: storeData.inspectionData?.data?.guid,

    };
    setCategoryHighlighted(true);
    setTempDuplicateCategoryIdx(categoryIdx + 1);
    setDuplicatedCategoryTemplateIdx(templateIdx);
    setDuplicateCategoryIconClicked(true);
    await ApiCallDuplicateCategory(dispatch, formData);
    setTimeout(() => {
      setCategoryHighlighted(false);
      setDuplicateCategoryIconClicked(false);
    }, 2000);
  };

  const handleConfirmDeleteLine = async () => {
    let templateIndex = inspectionResponse?.inspectiontemplates?.findIndex((itm) => itm.template_id === activeDeleteAndDuplicateTemplate.template_id);
    let categoryIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.id === activeDeleteAndDuplicateCategory?.id);
    let lineIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines.findIndex((itm) => itm.uuid == activeDeleteLine.uuid);
    let prevData = JSON.parse(JSON.stringify(inspectionResponse));
    delete prevData?.report_media_library_files;
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].is_deleted = 1;
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines?.map(async (item, index) => {
      item.order = index + 1;
      item.updated_at = await GetUTCTime();
      return item;
    });
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].updated_at = await GetUTCTime();
    setDeleteLineToast(true);
    let filteredObject = cleanPayloadOnLineLevel(prevData, templateIndex, categoryIndex, lineIndex);
    UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    setShowDeleteLineModal(false);
    setActiveLine("");
    dispatch(activateLines(""));
    navigate(
      `/inspection/${activeDeleteAndDuplicateCategory.prompt !== null && activeDeleteAndDuplicateCategory.prompt !== "" ? encodeURIComponent(activeDeleteAndDuplicateCategory.prompt) : "Untitled"}`,
      {
        state: {
          activeDeleteAndDuplicateCategory,
          template: activeDeleteAndDuplicateTemplate,
          template_id: activeDeleteAndDuplicateTemplate?.template_id,
          category_id: activeDeleteAndDuplicateCategory.id,
          category_uuid: activeDeleteAndDuplicateCategory.uuid,
          parent_uuid: activeDeleteAndDuplicateCategory?.parent_uuid
        },
      }
    );
  };

  const handleConfirmDeleteCategory = async (e) => {
    let templateIndex = inspectionResponse?.inspectiontemplates?.findIndex((itm) => itm.template_id === activeDeleteAndDuplicateTemplate.template_id);
    let categoryIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.id === activeDeleteCategory?.id);
    let prevData = JSON.parse(JSON.stringify(inspectionResponse));
    delete prevData?.report_media_library_files;
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].is_deleted = 1;
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].updated_at = await GetUTCTime();
    let syncCategory = [prevData.inspectiontemplates[templateIndex].categories[categoryIndex]];
    let deletedCatArray = JSON.parse(JSON.stringify(prevData));
    deletedCatArray.inspectiontemplates[templateIndex].categories = syncCategory;
    let filteredObject = cleanPayloadOnCategoryLevel(prevData, templateIndex, categoryIndex);
    UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    setDeleteCategoryModal(false);
    setDeleteCategoryToast(true);
    navigate("/inspection", {
      state: {
        template: activeDeleteAndDuplicateTemplate,
        template_id: activeDeleteAndDuplicateTemplate?.template_id,
      },
    });
  };

  const callInitiateAPIWithOutLoader = async () => {
    let sessionAssociateCompanyKey = await Base64.decode(sessionStorage.getItem("AC"));
    let guid = await sessionStorage.getItem("guid");
    let sessionUserId = await Base64.decode(sessionStorage.getItem("UI"));
    await dispatch(
      getInspectionDataWithOutLoader({
        guid: guid,
        associate_company: sessionAssociateCompanyKey,
        user_id: sessionUserId,
      })
    );
  };

  const fetchData = async () => {
    let isMounted = true;
    await callInitiateAPIWithOutLoader()
      .then(() => {
        if (isMounted) {
          setTimeout(() => {
            setDuplicateCategoryIconClicked(false);
            setDuplicateLineIconClicked(false);
            setLineHighlighted(false);
            setCategoryHighlighted(false);
          }, 2000);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return () => {
      isMounted = false;
    };
  };
  useEffect(() => {
    if ((storeData?.inspectionData && storeData?.duplicateCategoryResponse) || (storeData?.inspectionData && storeData?.duplicateLineResponse)) {
      fetchData();
    }
  }, [storeData?.inspectionData && storeData?.duplicateCategoryResponse, storeData?.inspectionData && storeData?.duplicateLineResponse]);

  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/inspection") {
      setActive("");
    } else if (urlState?.clickedFrom || clickedFrom !== "sideMenu") {
      setActiveTemplate(urlState?.template_id);
      if (urlState?.category !== undefined || urlState?.pdfcategory !== undefined)
        disableSwitch ? setActive("") : urlState.isPDF !== 1 ? setActive(urlState?.category?.uuid) : setActive(urlState?.pdfcategory?.uuid);
      setDisableSwitch(false);
      setClickedFrom(urlState?.clickedFrom)
    }
  }, [urlState, clickedFrom, location.pathname]);

  // A Move to / Copy to toast link can jump to a line far down the menu; once the menu has expanded and
  // highlighted it, scroll it into view. "nearest" leaves the menu still when the line is already visible.
  useEffect(() => {
    if (urlState?.clickedFrom !== MOVE_COPY_TOAST_NAV_SOURCE) return undefined;
    const frameId = requestAnimationFrame(() => {
      const activeMenuItem = document.querySelector(".navlink.active_line") ?? document.querySelector(".navlink.active_category");
      activeMenuItem?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
    return () => cancelAnimationFrame(frameId);
  }, [urlState, active, storeData?.activeLineUuid]);

  const handleCloseDeleteAlert = () => {
    setShowDeleteLineModal(false);
  };

  const handleLineDelete = (line, lineIdx, category, template) => {
    setActiveDeleteAndDuplicateCategory(category);
    setActiveDeleteAndDuplicateTemplate(template);
    setActiveDeleteLine(line);
    setShowDeleteLineModal(true);
    setActiveLineIdx(lineIdx);
  };

  const handleCategoryDelete = (category, e, categoryIdx) => {
    setDeleteCategoryModal(true);
    setActiveDeleteCategory(category);
    setActiveDeleteCategoryIdx(categoryIdx);
  };

  const handleCloseCategoryDeleteAlert = () => {
    setDeleteCategoryModal(false);
  };

  const activeHandle = (currentActive) => {
    if (active === currentActive) {
      setDisableSwitch(true);
      setActive("");
    } else {
      setDisableSwitch(false);
      setActive(currentActive);
    }
    setActiveLine("");
    setDisableCatActive(false);
    setActiveTemplate("");
    dispatch(activateLines(""));
  };
  const activeHandleLine = (currentActive) => {
    setDisableSwitch(false);
    setDisableCatActive(true);
    if (active === currentActive) setActiveLine("");
    else {
      dispatch(activateLines(currentActive));
    }
    setActiveTemplate("");
  };
  const activeTemplateHandle = (active) => {
    setDisableSwitch(false);
    setDisableCatActive(false);
    setActiveTemplate(active);
    setActive("");
    setActiveLine("");
  };

  const clearEditStatuses = () => {
    dispatch(editCategory(false));
    dispatch(reorderCategory(false));
    dispatch(reorderLines(false));
    dispatch(editLine(false));
    dispatch(scrollTop(true));
    dispatch(clearActiveLine());
  };

  const handleAddCategory = (templateGuid, templateid) => {
    setNewCategoryList([]);
    getDefaultCategories(dispatch, templateGuid);
    setShowCategoryModal(true);
    setSelectedCategories([]);
    setTemplateData(storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateid));
    dispatch(getTemplateListCall(sessionStorage.getItem("guid")));
    setSelectedTemplate(templateGuid);
  };

  const handleTemplateDropdownChange = (guid) => {
    setSelectedTemplate(guid);
    getDefaultCategories(dispatch, guid);
  };

  const handleSelectedDropdownTemplateGuid = (guid) => {
    setSelectedDropdownTemplateGuid(guid);
  }

  const handleCategorySelection = (category) => {
    if (category.is_selected === false) category.is_selected = true;
    if(selectedDropdownTemplateGuid && selectedDropdownTemplateGuid != templateData?.template_guid)
      category.template_guid = selectedDropdownTemplateGuid;
    if (selectedCategories.length === 0) {
      setSelectedCategories([category]);
    } else {
      setSelectedCategories((prev) => {
        let catIndex = prev.findIndex((item) => item.uuid === category.uuid);
        if (catIndex !== -1) {
          return prev.filter((prevCategory) => prevCategory.uuid !== category.uuid);
        } else return [...prev, category];
      });
    }
  };

  const handleLineSelection = (line, lineType) => {
    setSelectedLines((prev) => {
      let catIndex = prev.findIndex((item) => item.sourceUuid === line.uuid);
      if (catIndex !== -1) {
        return prev.filter((prevCategory) => prevCategory.sourceUuid !== line.uuid);
      } else return [...prev, { ...line, optional: 0, uuid: uuidv4(), sourceUuid: line.uuid }];
    });
  };

  const handleAddLine = (isInspDetails, parentUuid) => {
    if (isInspDetails) {
      setShowInspLineModal(true);
    } else {
      if (parentUuid !== null) {
        getDefaultLines(dispatch, {
          templateGuid: storeData.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId)?.template_uuid,
          parentUuid: storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId)?.categories?.find((category) => category.id === categoryId)
            ?.parent_uuid,
        });
      } else {
        setNewLineList([]);
      }
      setShowLineModal(true);
    }
    setSelectedLines([]);
  };

  const assosiatedCategoryColor = (category, assignColorList) => {
    const { catwiseFlagListData } = allInspectorFlagging(inspectionResponse?.inspectiontemplates);
    const categoryData = catwiseFlagListData.find((item) => item?.category_id === category?.uuid);
    if (!categoryData?.inspector_flagging_guids || categoryData?.inspector_flagging_guids?.length === 0) {
      return [];
    }
    const uniqueGuids = [...new Set(categoryData.inspector_flagging_guids)];
    return uniqueGuids
      .map((guid) => {
        const matchedColor = assignColorList?.filter((item) => item.is_deleted !== 1).find((item) => item.guid === guid);
        return matchedColor ? matchedColor.color_code : null;
      })
      ?.filter((item) => item !== null);
  };

  const assosiatedLineColor = (inspector_flagging_guids, assignColorList) => {
    if (!inspector_flagging_guids || inspector_flagging_guids?.length === 0) {
      return [];
    }
    return inspector_flagging_guids
      .map((guid) => {
        const matchedColor = assignColorList?.filter((item) => item.is_deleted !== 1).find((item) => item.guid === guid);
        return matchedColor ? matchedColor.color_code : null;
      })
      ?.filter((item) => item !== null);
  };

  const categorylineRelation = (template, relationcategoryData, lineRelationData) => {
    categoryLineRelation(dispatch, {
      templateGuid: template?.master_template_guid,
      categoryUuid: relationcategoryData?.parent_uuid !== null ? relationcategoryData?.parent_uuid : relationcategoryData?.uuid,
      lineUuid: lineRelationData?.uuid,
      lineParentUuid: lineRelationData?.parent_uuid === null || lineRelationData?.parent_uuid === undefined ? lineRelationData?.uuid : lineRelationData?.parent_uuid,
    });
  };

  let PORTAL_URL = portalUrl();
  useEffect(() => {
    if (storeData.inspectionData) {
      setInspectionResponse(storeData.inspectionData?.data);
      storeData.inspectionData?.data?.order_id !== undefined && sessionStorage.setItem("orderId", storeData.inspectionData?.data?.order_id);
      storeData.inspectionData?.data?.location_address !== undefined && sessionStorage.setItem("location_address", storeData.inspectionData?.data?.location_address);
      storeData.inspectionData?.data?.location_address_2 !== undefined && sessionStorage.setItem("location_address_2", storeData.inspectionData?.data?.location_address_2);
      storeData.inspectionData?.data?.location_city !== undefined && sessionStorage.setItem("location_city", storeData.inspectionData?.data?.location_city);
      storeData.inspectionData?.data?.location_state !== undefined && sessionStorage.setItem("location_state", storeData.inspectionData?.data?.location_state);
      storeData.inspectionData?.data?.location_zip !== undefined && sessionStorage.setItem("location_zip", storeData.inspectionData?.data?.location_zip);
      storeData.inspectionData?.data?.user_displayname !== undefined && sessionStorage.setItem("user_displayname", storeData.inspectionData?.data?.user_displayname);
      storeData.inspectionData?.data?.user_email !== undefined && sessionStorage.setItem("user_email", storeData.inspectionData?.data?.user_email);
      storeData.inspectionData?.data?.company?.logo !== undefined && sessionStorage.setItem("logo", storeData.inspectionData?.data?.company?.logo);
    }
  }, [storeData.inspectionData]);
  // useEffect(() => {
  //   setSelectedTemplate(templateData?.template_guid)
  //   if (storeData.inspectionData?.data?.get_templates && storeData.inspectionData?.data?.get_templates === 1) {
  //     setShowStaticBackground(true);
  //   } else setShowStaticBackground(false);
  //   if (storeData?.staticBG === true || storeData?.staticBG === undefined) setStaticBG(true);
  //   else setStaticBG(false);
  // }, [storeData.inspectionData?.data]);

  useEffect(() => {
    if (storeData?.updatedInspectionData?.success === true && deleteLineToast) {
      toast.success("The category has been updated successfully.");
      setDeleteLineToast(false);
    }
    if (storeData?.updatedInspectionData?.success === true && deleteCategoryToast) {
      toast.success("Category has been deleted.");
      setDeleteCategoryToast(false);
    }
  }, [handleConfirmDeleteCategory, handleConfirmDeleteLine]);

  useEffect(() => {
    if (storeData.inspectionData) {
      setCategoryData(storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId)?.categories?.find((category) => category.id === categoryId));
    }
  }, [storeData.inspectionData, urlState]);

  // optional and standard categories
  useEffect(() => {
    if(storeData?.lineDataError?.response?.status === 404){
      setNewLineList({standard:categoryData?.lines?.filter(
        (item) => item.is_deleted === 0
      )});
    }else if (storeData.defaultLineData) {
      setNewLineList(storeData.defaultLineData?.length !== 0 ? storeData.defaultLineData?.data : []);
    }
  }, [storeData.defaultLineData,storeData?.lineDataError]);

  // optional and standard categories
  useEffect(() => {
    if (storeData.defaultCategoryList) {
      setNewCategoryList(storeData.defaultCategoryList?.length !== 0 ? storeData.defaultCategoryList?.data : []);
    }
  }, [storeData.defaultCategoryList]);

  const validUrl = useLocation()?.pathname;
  const isReportMediaLibraryUrl = validUrl === "/report_media_library";
  // Identity must never be inferred from the franchise logo: it is an optional image
  // field, so an empty or renamed logo would silently change what the sidebar shows.
  const isHtCompany = isHTCompanyKey();
  let activeLineCondition = !disableCatActive && (storeData?.activeLineUuid === "" || storeData?.activeLineUuid === undefined);
  let reportMediaPercentage =
    storeData?.successfulBulkUploadMediaLength == 0 && storeData?.failBulkUploadMediaLength > 0 ? 0 : `${(storeData?.successfulBulkUploadMediaLength / storeData?.bulkUploadMediaLength) * 100}`;

 function mergeObjectsByCategoryId(data) {
    const mergedObjects = {};
    data?.forEach((item) => {
      if (item) {
        [item].forEach((innerItem) => {
          const categoryId = innerItem.category_id;
          if (!mergedObjects[categoryId]) {
            mergedObjects[categoryId] = { ...innerItem };
          } else {
            mergedObjects[categoryId].value = mergedObjects[categoryId]?.value?.concat(innerItem.value);
          }
        });
      }
    });
    return Object.values(mergedObjects);
  }
  const getMediaCount = () => {
  const templateMediaString = "template-editor/";
    let media = [];
    storeData?.inspectionDataForBulkMedia?.data?.report_media_library_files?.forEach((item) => {
          // Template media never belongs in the report media library.
          if (item?.online_url?.startsWith(templateMediaString) || item?.thumbnail_url?.startsWith(templateMediaString)) {
            return;
          }
          media.push({ ...item, onlineUrl: item?.online_url, thumbnail: item?.thumbnail_url, type: item?.media_type, edited: false });
        });
    storeData?.inspectionDataForBulkMedia?.data?.inspectiontemplates?.forEach((template) => {
          if (template.is_pdf_template !== 1) {
            template?.categories?.forEach((category) => {
              category?.introductory_text_media?.forEach((image) => {
                if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                  return;
                }
                let times_used = 1;
                if (category?.is_deleted === 1 || image?.is_deleted === 1) {
                  times_used = 0;
                }
                if (image?.is_report_media_library_file) {
                  media?.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                } else {
                  media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                }
              });
              category?.lines?.forEach((line) => {
                line?.line_input_controls !== null &&
                  line?.line_input_controls !== undefined &&
                  line?.line_input_controls.length !== 0 &&
                  line?.line_input_controls
                    ?.filter((data) => data.type === "Media")
                    ?.forEach((MediaData) => {
                      MediaData?.data?.forEach((image) => {
                        if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                          return;
                        }
                        let times_used = 1;
                        if (category?.is_deleted === 1 || line?.is_deleted === 1 || image?.is_deleted === 1) {
                          times_used = 0;
                        }
                        if (image?.is_report_media_library_file) {
                          media.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                        } else {
                          media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                        }
                      });
                    });
                line?.line_input_controls?.filter((data) => data?.type == "Nameplate")?.[0]?.data?.image &&
                  media.push(line?.line_input_controls?.filter((data) => data?.type == "Nameplate")?.[0]?.data?.image);
                line?.comments?.length !== 0 &&
                  line?.comments?.forEach((comment) =>
                    comment?.comment_input_controls
                      ?.filter((data) => data.type === "Media")
                      ?.forEach((innerData) => {
                        innerData?.data?.forEach((image) => {
                          if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                            return;
                          }
                          let times_used = 1;
                          if (image?.is_deleted === 1) {
                            times_used = 0;
                          }
                          if (image?.is_report_media_library_file) {
                            media.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                          } else {
                            media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                          }
                        });
                      })
                  );
              });
            });
          } else {
            {
              mergeObjectsByCategoryId(
                template?.pdf_data?.filter((category) => {
                  return category?.type === "MediaUploader" && category;
                })
              )?.forEach((item) => {
                if (item.value.length !== 0) {
                  item.value?.forEach((image) => {
                    if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                      return;
                    }
                    let times_used = 1;
                    if (image?.is_deleted === 1) {
                      times_used = 0;
                    }
                    if (image?.is_report_media_library_file) {
                      media.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                    } else {
                      media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                    }
                  });
                } else return null;
              });
            }
          }
        });
        let uniqueMedia = [];
        let mediaWithOriginal = [];
        media.forEach((mediaItem) => {
          const mediaDeletedFromRML = mediaItem?.is_deleted_from_rml || 0;
          const mediaIndex = mediaWithOriginal.findIndex((itm) => {
            return mediaItem.uuid == itm.uuid;
          });
          const mediaIndexByName = mediaWithOriginal.findIndex((itm) => {
            return mediaItem.name == itm.name;
          });
          if (mediaIndex !== -1) {
            mediaWithOriginal[mediaIndex]["isUserMade"] = true;
            const newItemIsDeleted = mediaItem?.is_deleted || 0;
            const mediaIndexLocal = mediaWithOriginal.findIndex((itm) => {
              return mediaItem.uuid == itm.uuid;
            });
            mediaWithOriginal[mediaIndexLocal].times_used = mediaItem.times_used;
            if (newItemIsDeleted === 0 && mediaItem?.template_media && mediaIndexLocal !== -1) {
              if (mediaItem?.edited == false) {
                mediaWithOriginal[mediaIndexLocal].times_used = (mediaWithOriginal[mediaIndexLocal].times_used || 0) + 1;
              }
              mediaWithOriginal[mediaIndexLocal]["isUserMade"] = true;
              if (mediaWithOriginal[mediaIndexLocal].updated_at < mediaItem?.updated_at) {
                mediaWithOriginal[mediaIndexLocal].updated_at = mediaItem?.updated_at;
              }
            }
            // add only edited
            if (mediaItem?.edited && mediaDeletedFromRML !== 2 && mediaDeletedFromRML !== 3) {
              if (mediaIndexByName == -1) {
                mediaWithOriginal.push({
                  ...mediaItem,
                  uuid: uuidv4(),
                  created_at: mediaItem?.updated_at,
                  times_used: mediaItem?.is_deleted ? 0 : 1,
                });
              }
            }
          } else {
            const mediaDeletedFromRML = mediaItem?.is_deleted_from_rml || 0;
            if (mediaItem?.edited) {
              //store original as well
              if (mediaDeletedFromRML === 0 || mediaDeletedFromRML === 2) {
                let originalImage = {
                  ...mediaItem,
                  thumbnail: mediaItem.OriginThumbnail,
                  newUrl: mediaItem?.OriginUrl,
                  onlineUrl: mediaItem?.OriginUrl,
                  id: uuidv4(),
                  name: mediaItem?.OrginName || mediaItem?.orginName,
                  edited: false,
                  uploaded_by: mediaItem?.edited_by,
                  editCount: 0,
                  times_used: 0,
                  isUserMade: true,
                };
                const mediaIndexByNameLocal = mediaWithOriginal.findIndex((itm) => {
                  // An original without a name (older edits lost it) would otherwise match every nameless item and be dropped.
                  return originalImage.name ? originalImage.name == itm.name : originalImage.onlineUrl === itm.onlineUrl;
                });
                if (mediaIndexByNameLocal == -1) {
                  mediaWithOriginal.push(originalImage);
                }
              }
              //push edited if 0 or 1, or if original slot is taken and this edit is unique
              if (mediaDeletedFromRML === 0 || mediaDeletedFromRML === 1) {
                const editedItem = { ...mediaItem, created_at: mediaItem?.updated_at, times_used: 1 };
                if (mediaIndexByName == -1) {
                  mediaWithOriginal.push(editedItem);
                }
              }
            } else {
              if (mediaDeletedFromRML !== 1 && mediaDeletedFromRML !== 3) {
                if (mediaIndexByName == -1) {
                  mediaWithOriginal.push(mediaItem);
                }
              }
            }
          }
        });
        uniqueMedia = mediaWithOriginal?.filter((item) => item?.online !== "offline" && item?.is_deleted_from_rml !== 3);
     return [
      (uniqueMedia?.length) > 0 && `${uniqueMedia?.length} item${(uniqueMedia?.length) !== 1 ? "s" : ""}`,
    ].filter(Boolean).join(" · ");
  };

  return (
    <>
      <AddLineModal
        showInspLineModal={showInspLineModal}
        setShowInspLineModal={setShowInspLineModal}
        templateId={templateId}
        categoryId={categoryId}
        isInspDetails={categoryData?.is_inspection_details}
      />
      <CreateNewLineModal
        showCreateNewLineModal={showCreateNewLineModal}
        setShowCreateNewLineModal={setShowCreateNewLineModal}
        setShowLineModal={setShowLineModal}
        templateId={templateId}
        categoryId={categoryId}
        isInspDetails={categoryData?.is_inspection_details}
      />
      <AddOptionalNdStandardLineModal
        showLineModal={showLineModal}
        setShowLineModal={setShowLineModal}
        templateId={templateId}
        categoryId={categoryId}
        isInspDetails={categoryData?.is_inspection_details}
        newLineList={newLineList}
        selectedLines={selectedLines}
        setSelectedLines={setSelectedLines}
        handleLineSelection={handleLineSelection}
        setShowCreateNewLineModal={setShowCreateNewLineModal}
      />
      <AddCategoryModal
        newCategoryList={newCategoryList}
        templateData={templateData}
        showCategoryModal={showCategoryModal}
        setShowCategoryModal={setShowCategoryModal}
        showCreateCategoryModal={showCreateCategoryModal}
        setShowCreateCategoryModal={setShowCreateCategoryModal}
        handleCategorySelection={handleCategorySelection}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        setSelectedTemplate={setSelectedTemplate}
        selectedTemplate={selectedTemplate}
        handleTemplateDropdownChange={handleTemplateDropdownChange}
        setSelectedDropdownTemplateGuid={handleSelectedDropdownTemplateGuid}
      />
      <CreateNewCategoryModal
        newCategoryList={newCategoryList}
        setNewCategoryList={setNewCategoryList}
        templateData={templateData}
        showCreateCategoryModal={showCreateCategoryModal}
        setShowCreateCategoryModal={setShowCreateCategoryModal}
        showCategoryModal={showCategoryModal}
        setShowCategoryModal={setShowCategoryModal}
        handleCategorySelection={handleCategorySelection}
      />
      <Grid className="component h_100 flex_props sticky">
        <Grid className="sidemenu">
          <div className="company__logo">
            {inspectionResponse?.franchise_logo ?
              <img className={isHtCompany ? "dynamic_logo dynamic_logo--ht" : "dynamic_logo"} src={inspectionResponse?.franchise_logo} alt="logo" />
              : null}
          </div>
          <div className="company_adress">
            {showStaticBackground || staticBG ? (
              <>
                <Typography>----------</Typography>
                <Typography>
                  <b>---------------------</b>
                </Typography>
              </>
            ) : (
              <>
                <Typography>Order #{sessionStorage.getItem("orderId")}</Typography>
                <Typography>
                  {sessionStorage.getItem("location_address") !== "null" && sessionStorage.getItem("location_address") !== "" ? `${sessionStorage.getItem("location_address")},` : ""}{" "}
                  {sessionStorage.getItem("location_address_2") !== "null" && sessionStorage.getItem("location_address_2") !== "" ? `${sessionStorage.getItem("location_address_2")},` : ""}{" "}
                  {`${sessionStorage.getItem("location_city")} `}
                  {`${sessionStorage.getItem("location_state")} `?.toUpperCase()} {sessionStorage.getItem("location_zip")}
                </Typography>
              </>
            )}
          </div>
          <div className="progress__section">
            <div className="is__relative">
              <Typography>Total Progress</Typography>
              <Typography>
                {totalLineCountCalulate(inspectionResponse?.inspectiontemplates)?.overallLinesCompleted}/{totalLineCountCalulate(inspectionResponse?.inspectiontemplates)?.overallLinesPresent}
              </Typography>
              <BorderLinearProgress variant="determinate" value={totalLineCountCalulate(inspectionResponse?.inspectiontemplates)?.overallPrecent} />
            </div>
          </div>
          <div className="menu__section">
            <div className="overview__section">
              <Typography sx={{ textTransform: "uppercase" }}>Inspection overview</Typography>
              <Divider style={{ marginBottom: "10px" }} />
              <NavLink className="navlink" to={{ pathname: `/` }} style={{ textDecoration: "none" }} id="introduction_">
                <Typography className="list__item">
                  <HomeOutlinedIcon />
                  <span className="list__text">Introduction</span>
                </Typography>
              </NavLink>
              {!zeroState ? <><NavLink className="navlink" to={{ pathname: `/report_media_library` }} style={{ textDecoration: "none" }}>
                <Grid container className="list__item" sx={{ backgroundColor: isReportMediaLibraryUrl && "#4282e2 !important", display: "flex" }}>
                  <Grid item xs={0.7}>
                    <ReportLibraryIcon validUrl={validUrl} />
                  </Grid>
                  <Grid item xs={6}>
                    <span className="list__text" style={{ color: isReportMediaLibraryUrl ? "white" : "#4282e2" }}>
                      Report Media Library
                    </span>
                    {/* <Box sx={{ fontSize: "11px !important", color: isReportMediaLibraryUrl ? "rgba(255,255,255,0.8)" : "#757575", marginTop: "1px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      Manage all the media for your report
                      </Box> */}
                  </Grid>
                 {reportMediaPercentage === "NaN"?<Grid className="list__text" sx={{ color: isReportMediaLibraryUrl ? "rgba(255,255,255,0.8)" : "#3b3b3b", marginTop: "2px"}} item xs={4.2} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
                    {getMediaCount()}
                  </Grid>:<Grid item xs={4} display={"flex"} justifyContent={"flex-end"} gap={1} alignItems={"center"}>
                    {reportMediaPercentage === "NaN" ? undefined : (
                      <BorderLinearProgress
                        sx={{
                          width: "80% !important",
                          height: "10px !important",
                          backgroundColor: "transparent !important", // Ensure transparency
                          opacity: 1,
                          "& .MuiLinearProgress-bar": {
                            backgroundColor: isReportMediaLibraryUrl ? "white !important" : "#4282e2 !important",
                            opacity: 1,
                          },
                        }}
                        variant="determinate"
                        value={reportMediaPercentage}
                      />
                    )}
                    {reportMediaPercentage === "NaN" ? undefined : (
                      <div style={{ color: isReportMediaLibraryUrl ? "white" : "#4282e2", marginRight: "-18px", fontWeight: 600 }}>{`${parseInt(reportMediaPercentage)}%`}</div>
                    )}
                  </Grid>}
                </Grid>
              </NavLink>
                {isHtCompany ? null : <NavLink className="navlink" to={{ pathname: `/review` }} style={{ textDecoration: "none" }}>
                  <Typography className="list__item">
                    <InsertDriveFileOutlinedIcon />
                    <span className="list__text">Review</span>
                  </Typography>
                </NavLink>}
              </> : ""}
            </div>
            <div className="report__section">
              {inspectionResponse?.inspectiontemplates && <><Typography sx={{ textTransform: "uppercase" }}>Report</Typography>
                <Divider style={{ marginBottom: "10px" }} /></>}
            </div>
            <div style={{ overflow: "hidden" }}>
              <Box id="sideMenuBox" sx={{ overflow: "auto" }}>
                {showStaticBackground || staticBG ? (
                  <List disablePadding className="menu__items" style={{ marginBottom: "35vh" }}>
                    <NavLink className={`navlink`} style={{ textDecoration: "none" }}>
                      <ListItem disablePadding className="list__item">
                        <ListItemButton disableRipple>
                          <ListItemIcon>
                            <AssignmentOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText className="list__text" primary={"No template added yet"} />
                        </ListItemButton>
                      </ListItem>
                    </NavLink>
                  </List>
                ) : (
                  <>
                    {inspectionResponse?.inspectiontemplates?.map(
                      (template, templateIdx) =>
                        template?.is_pdf_template !== 1 && template?.is_narrative_template !== 1 ? (
                          <div key={templateIdx}>
                            <List key={templateIdx} disablePadding className="menu__items">
                              <NavLink
                                className={`navlink ${activeTemplate === template.template_id ? "active_template" : ""}`}
                                to={{ pathname: `/inspection` }}
                                state={{ template, template_id: template.template_id, tempIndex: templateIdx }}
                                style={{ textDecoration: "none" }}
                                onClick={() => clearEditStatuses()}
                                id={`template_${templateIdx + 1}`}
                              >
                                <ListItem disablePadding className="list__item" onClick={() => activeTemplateHandle(template.template_id)}>
                                  <ListItemButton disableRipple>
                                    <ListItemIcon>
                                      <AssignmentOutlinedIcon />
                                    </ListItemIcon>
                                    <ListItemText className="list__text" primary={template.name} />
                                  </ListItemButton>
                                </ListItem>
                              </NavLink>
                            </List>
                            <div className="menu__categories__section">
                              {template.categories?.map((category, categoryIdx) =>
                                category.is_deleted !== 1 ? (
                                  <div key={categoryIdx} style={{ marginBottom: "4px" }}>
                                    {category?.is_inspection_details === 1 && getNonNarrativeTemplatesGuid(inspectionResponse?.inspectiontemplates)?.[0] !== template.template_guid ? null : (
                                      <>
                                        <List
                                          key={categoryIdx}
                                          disablePadding
                                          className={duplicatedCategoryTemplateIdx === templateIdx && tempDuplicateCategoryIdx === categoryIdx && !category?.showEmpty && "duplicated_category"}
                                          sx={{
                                            animation:
                                              duplicatedCategoryTemplateIdx === templateIdx &&
                                              categoryHighlighted &&
                                              tempDuplicateCategoryIdx === categoryIdx &&
                                              category?.showEmpty &&
                                              "fadeIn 0.5s ease,increaseHeight 0.5s forwards",
                                          }}
                                        >
                                          <NavLink
                                            className={`navlink ${activeTemplate === template.template_id && active === category.uuid && activeLineCondition ? "active_category" : ""}`}
                                            to={{ pathname: `/inspection/${category.prompt !== null && category?.prompt !== "" ? encodeURIComponent(category.prompt) : "Untitled"}` }}
                                            state={{
                                              category,
                                              template_id: template.template_id,
                                              category_id: category.id,
                                              category_uuid: category.uuid,
                                              assosiatedCategoryColors: assosiatedCategoryColor(category, assignColorList),
                                              parent_uuid: category?.parent_uuid,
                                            }}
                                            style={{ textDecoration: "none" }}
                                            onClick={() => {
                                              clearEditStatuses();
                                              setClickedFrom("sideMenu")
                                              setActiveTemplate(template.template_id);
                                              setActive(category.uuid);
                                              setActiveDeleteAndDuplicateCategory(category);
                                              setActiveDeleteAndDuplicateTemplate(template);
                                            }}
                                            id={`category_${categoryIdx}`}
                                            onMouseEnter={() => {
                                              if (category.is_inspection_details !== 2 && !category?.showEmpty) {
                                                setIsCategoryHovered(true);
                                                setIsHoveredCategoryUuid(category?.uuid);
                                              }
                                            }}
                                            onMouseLeave={() => {
                                              if (category.is_inspection_details !== 2 && !category?.showEmpty) {
                                                setIsCategoryHovered(false);
                                              }
                                            }}
                                          >
                                            <ListItem disablePadding className="categories__list">
                                              <ListItemButton disableRipple>
                                                {duplicatedCategoryTemplateIdx === templateIdx && categoryHighlighted && tempDuplicateCategoryIdx === categoryIdx ? (
                                                  <Skeleton variant="text" sx={{ width: "100%", paddingBottom: "1.5rem", marginBottom: "1.5rem", marginTop: "-0.75rem" }} />
                                                ) : (
                                                  <>
                                                    <div className="list__content" onClick={() => activeHandle(category.uuid)}>
                                                      <Grid container>
                                                        <Grid
                                                          item
                                                          xs={1}
                                                          justifyContent={"center"}
                                                          display={"flex"}
                                                          alignItems={"center"}
                                                          flexDirection={"row"}
                                                        >
                                                          <>
                                                            {assosiatedCategoryColor(category, assignColorList)?.length <= 2 &&
                                                              assosiatedCategoryColor(category, assignColorList)?.map((color, index) => (
                                                                <div
                                                                  key={index}
                                                                  style={{
                                                                    position: "absolute",
                                                                    width: "15px",
                                                                    height: "15px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: color,
                                                                    border: "2px solid #FFFFFF",
                                                                    top: index === 0 ? assosiatedCategoryColor(category, assignColorList)?.length <= 1 ? "3px" : "-4px" : "10px",
                                                                    left: index === 0 ? assosiatedCategoryColor(category, assignColorList)?.length <= 1 ? "4px" : "4px" : "4px",
                                                                  }}
                                                                ></div>
                                                              ))}
                                                            {assosiatedCategoryColor(category, assignColorList)?.length >= 3 &&
                                                              assosiatedCategoryColor(category, assignColorList)
                                                                ?.slice(0, 3)
                                                                ?.map((color, index) => (
                                                                  <div
                                                                    key={index}
                                                                    style={{
                                                                      position: "absolute",
                                                                      width: "15px",
                                                                      height: "15px",
                                                                      borderRadius: "50%",
                                                                      backgroundColor: color,
                                                                      border: "2px solid #FFFFFF",
                                                                      top: index === 0 ? "-4px" : index === 1 ? "11px" : "3px",
                                                                      left: index === 0 ? "4px" : index === 1 ? "4px" : "12px",
                                                                    }}
                                                                  ></div>
                                                                ))}
                                                            {assosiatedCategoryColor(category, assignColorList)?.length > 3 && (
                                                              <div
                                                                style={{
                                                                  position: "absolute",
                                                                  top: "-13px",
                                                                  left: "18px",
                                                                  fontSize: "14px",
                                                                  fontWeight: "bold",
                                                                  color: "#000",
                                                                }}
                                                              >
                                                                +
                                                              </div>
                                                            )}
                                                          </>
                                                        </Grid>
                                                        <Grid item xs={10}>
                                                          <span
                                                            style={{ display: "block", width: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}
                                                            className={
                                                              duplicatedCategoryTemplateIdx === templateIdx &&
                                                              categoryHighlighted &&
                                                              tempDuplicateCategoryIdx === categoryIdx &&
                                                              !category?.showEmpty &&
                                                              "pulse-once"
                                                            }
                                                          >
                                                            {category.prompt !== null && category?.prompt !== "" ? category.prompt : category?.showEmpty ? "" : "Untitled"}
                                                          </span>
                                                        </Grid>
                                                        <Grid item xs={1} display={"flex"} justifyContent={"flex-end"}>
                                                          {category.is_inspection_details == 1 ? (
                                                            template?.is_narrative_template === 1 ? (
                                                              <span>
                                                                {categoryPercentCalculateNarrative(category)?.lineComplete}/{categoryPercentCalculateNarrative(category)?.totalLines}
                                                              </span>
                                                            ) : (
                                                              <span>
                                                                {categoryPercentCalculate(category)?.lineComplete}/{categoryPercentCalculate(category)?.totalLines}
                                                              </span>
                                                            )
                                                          ) : (
                                                            (isHoveredCategoryUuid !== category?.uuid || !isCategoryHovered) && (
                                                              <>
                                                                {category?.showEmpty ? (
                                                                  ""
                                                                ) : (
                                                                  template?.is_narrative_template === 1 ? (
                                                                    <span>
                                                                      {categoryPercentCalculateNarrative(category)?.lineComplete}/{categoryPercentCalculateNarrative(category)?.totalLines}
                                                                    </span>
                                                                  ) : (
                                                                    <span>
                                                                      {categoryPercentCalculate(category)?.lineComplete}/{categoryPercentCalculate(category)?.totalLines}
                                                                    </span>
                                                                  )
                                                                )}
                                                              </>
                                                            )
                                                          )}
                                                          {category.is_inspection_details !== 1
                                                            ? isCategoryHovered &&
                                                            isHoveredCategoryUuid === category?.uuid && (
                                                              <>
                                                                {duplicateCategoryIconClicked ? (
                                                                  <span
                                                                    className="DuplicateIcon"
                                                                    onClick={(e) => {
                                                                      e.preventDefault();
                                                                      e.stopPropagation();
                                                                    }}
                                                                  >
                                                                    <GrDuplicate />
                                                                  </span>
                                                                ) : (
                                                                  <span
                                                                    className="DuplicateIcon"
                                                                    onClick={(e) => {
                                                                      handleDuplicateCategory(template?.template_id, category, e, categoryIdx, templateIdx);
                                                                      e.preventDefault();
                                                                    }}
                                                                  >
                                                                    <GrDuplicate />
                                                                  </span>
                                                                )}
                                                                <span
                                                                  className="DeleteIcon"
                                                                  onClick={(e) => {
                                                                    handleCategoryDelete(category, e, categoryIdx);
                                                                    e.preventDefault();
                                                                  }}
                                                                >
                                                                  <DeleteIcon />
                                                                </span>
                                                              </>
                                                            )
                                                            : ""}
                                                        </Grid>
                                                      </Grid>
                                                    </div>
                                                  </>
                                                )}
                                              </ListItemButton>
                                            </ListItem>
                                          </NavLink>
                                        </List>
                                      </>
                                    )}
                                    {activeTemplate === template.template_id && active === category.uuid ? <List disablePadding className={`${active === category.uuid ? "menu__line__section ul_active" : "menu__line__section"}`}>
                                      {category.lines?.map((line, lineIdx) => {
                                        let duplicateCategoryClassCondition = duplicateCategoryIdx == categoryIdx && tempDuplicateLineIdx === lineIdx && !line?.showLineEmpty;
                                        return line.is_deleted !== 1 ? (
                                          active === category.uuid ? (
                                            category.is_inspection_details !== 1 ? (
                                              <NavLink
                                                className={`navlink ${activeTemplate === template.template_id && activeLine === line.uuid || activeTemplate === template.template_id && storeData?.activeLineUuid === line.uuid ? "active_line" : ""}`}
                                                to={{
                                                  pathname: `/inspection/${category.prompt !== null && category?.prompt !== "" ? encodeURIComponent(category.prompt) : "Untitled"}/${line.prompt !== null && line?.prompt !== "" ? encodeURIComponent(line.prompt) : "Untitled"
                                                    }`,
                                                }}
                                                state={{
                                                  line,
                                                  template_id: template.template_id,
                                                  category_id: category.id,
                                                  category_uuid: category.uuid,
                                                  line_uuid: line.uuid,
                                                  template_guid: template.template_guid,
                                                  parent_uuid: category.parent_uuid,
                                                }}
                                                style={{ textDecoration: "none" }}
                                                onClick={() => {
                                                  categorylineRelation(template, category, line);
                                                  clearEditStatuses();
                                                  setActiveTemplate(template.template_id);
                                                  setActive(category.uuid);
                                                  setActiveDeleteAndDuplicateTemplate(template);
                                                  setActiveDeleteAndDuplicateCategory(category);
                                                }}
                                                onMouseEnter={(e) => {
                                                  !line?.showLineEmpty && setIsHovered(true);
                                                  setIsHoveredLineUuid(line.uuid);
                                                }}
                                                onMouseLeave={() => {
                                                  !line?.showLineEmpty && setIsHovered(false);
                                                }}
                                              >
                                                <ListItem
                                                  disablePadding
                                                  className={`${category.lines.length > lineIdx + 1 && "border__list "} is__relative menu__line__list`}
                                                  onClick={() => activeHandleLine(line.uuid)}
                                                >
                                                  <SvgIcon className="curve" viewBox="">
                                                    {category.lines.length > lineIdx + 1 ? curve : curveEnd}
                                                  </SvgIcon>
                                                  {!deleteCategoryModal && (
                                                    <ListItemButton disableRipple>
                                                      {line?.showLineEmpty && duplicateCategoryIdx == categoryIdx && lineHighlighted ? (
                                                        <>
                                                          {lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && (
                                                            <Skeleton variant="text" sx={{ width: "100%", height: "2.5rem", display: "block", marginLeft: "14px" }} />
                                                          )}
                                                          <div
                                                            className={
                                                              duplicateCategoryIdx == categoryIdx && lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && "animation-line"
                                                            }
                                                            style={{
                                                              animation:
                                                                duplicateCategoryIdx == categoryIdx &&
                                                                lineHighlighted &&
                                                                tempDuplicateLineIdx === lineIdx &&
                                                                line?.showLineEmpty &&
                                                                "fadeIn 0.5s ease,increaseHeight 0.5s forwards",
                                                            }}
                                                          >
                                                            {" "}
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <div
                                                          className={`list__content line__list__padding ${duplicateCategoryClassCondition ? "duplicated_line" : ""}`}
                                                          style={{
                                                            padding: assosiatedLineColor(line?.inspector_flagging_guids, assignColorList)?.length > 0 ? "5px 0px 5px 0px" : "10px 0px 10px 0px",
                                                            animation: lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && "fadeIn 0.5s ease,increaseHeight 0.5s forwards",
                                                          }}
                                                        >
                                                          <Grid container>
                                                            <Grid
                                                              item
                                                              xs={1}
                                                              justifyContent={"flex-end"}
                                                              display={"flex"}
                                                              alignItems={"center"}
                                                              flexDirection={assosiatedLineColor(line?.inspector_flagging_guids, assignColorList)?.length === 2 ? "column" : "row"}
                                                            >
                                                              <>
                                                                {line?.inspector_flagging_guids?.length === 1 && (
                                                                  <div style={{ position: "relative", width: "22px", height: "33px" }}>
                                                                    {assosiatedLineColor(line?.inspector_flagging_guids, assignColorList).map((color, index) => {
                                                                      const positions = [{ top: "10px", left: "0px" }];
                                                                      return <div key={index} style={{ position: "absolute", width: "15px", height: "15px", borderRadius: "50%", backgroundColor: color, ...positions[index], border: "2px solid #ffffff" }}></div>;
                                                                    })}
                                                                  </div>
                                                                )}
                                                                {line?.inspector_flagging_guids?.length === 2 && (
                                                                  <div style={{ position: "relative", width: "22px", height: "33px" }}>
                                                                    {assosiatedLineColor(line?.inspector_flagging_guids, assignColorList).map((color, index) => {
                                                                      const positions = [
                                                                        { top: "0px", left: "2px" },
                                                                        { top: "15px", left: "2px" },
                                                                      ];
                                                                      return <div key={index} style={{ position: "absolute", width: "15px", height: "15px", borderRadius: "50%", backgroundColor: color, ...positions[index], border: "2px solid #ffffff" }}></div>;
                                                                    })}
                                                                  </div>
                                                                )}
                                                                {line?.inspector_flagging_guids?.length >= 3 && (
                                                                  <div style={{ position: "relative", width: "22px", height: "33px" }}>
                                                                    {assosiatedLineColor(line?.inspector_flagging_guids, assignColorList)
                                                                      ?.slice(0, 3)
                                                                      ?.map((color, index) => {
                                                                        const positions = [
                                                                          { top: "2px", left: "0px" },
                                                                          { top: "16px", left: "0px" },
                                                                          { top: "8px", left: "8px" },
                                                                        ];
                                                                        return <div key={index} style={{ position: "absolute", width: "15px", height: "15px", borderRadius: "50%", backgroundColor: color, ...positions[index], border: "2px solid #ffffff" }}></div>;
                                                                      })}
                                                                    {line?.inspector_flagging_guids?.length > 3 && <div style={{ position: "absolute", top: "-8px", left: "16px", fontSize: "16px", fontWeight: "bold", color: "#3b3b3b", }}>+</div>}
                                                                  </div>
                                                                )}
                                                              </>
                                                            </Grid>
                                                            <Grid item xs={isHovered && isHoveredLineUuid === line.uuid ? 8 : 8.5} display="flex" alignItems="center" justifyContent="flex-start">
                                                              <span
                                                                style={{
                                                                  width: "100%",
                                                                  whiteSpace: "nowrap",
                                                                  overflow: "hidden",
                                                                  textOverflow: "ellipsis",
                                                                  display: "block",
                                                                  padding: "2px 0px 2px 5px"
                                                                }}
                                                                className={lineHighlighted && tempDuplicateLineIdx === lineIdx && !line?.showLineEmpty && "pulse-once"}>
                                                                {" "}
                                                                {line.prompt !== null && line?.prompt !== "" ? line.prompt : "Untitled"}
                                                              </span>
                                                            </Grid>
                                                            <Grid item={isHovered && isHoveredLineUuid === line.uuid ? 4 : 3} display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
                                                              <span style={{ display: "flex" }}>
                                                                <CheckCircleIcon
                                                                  className="done_icon"
                                                                  style={{
                                                                    visibility:
                                                                      template?.is_narrative_template === 1
                                                                        ? (line?.is_completed ? "visible" : "hidden")
                                                                        : ((isHoveredLineUuid !== line.uuid || !isHovered) && checkLineComplete(line, "normal"))
                                                                          ? "visible"
                                                                          : "hidden",
                                                                  }}
                                                                />
                                                                {isHovered && isHoveredLineUuid === line.uuid && (
                                                                  <>
                                                                    {duplicateLineIconClicked ? (
                                                                      <span
                                                                        className="DuplicateIcon"
                                                                        onClick={(e) => {
                                                                          e.preventDefault();
                                                                          e.stopPropagation();
                                                                        }}
                                                                      >
                                                                        <GrDuplicate />
                                                                      </span>
                                                                    ) : (
                                                                      <span
                                                                        className="DuplicateIcon"
                                                                        onClick={(e) => {
                                                                          handleDuplicateLine(template?.template_id, category?.uuid, line, e, lineIdx, categoryIdx);
                                                                          e.preventDefault();
                                                                        }}
                                                                      >
                                                                        <GrDuplicate />
                                                                      </span>
                                                                    )}
                                                                    <span
                                                                      style={{ display: "flex" }}
                                                                      className="DeleteIcon"
                                                                      onClick={(e) => {
                                                                        handleLineDelete(line, lineIdx, category, template);
                                                                        e.preventDefault();
                                                                      }}
                                                                    >
                                                                      <DeleteIcon />
                                                                    </span>
                                                                  </>
                                                                )}
                                                              </span>
                                                            </Grid>
                                                          </Grid>
                                                        </div>
                                                      )}
                                                    </ListItemButton>
                                                  )}
                                                </ListItem>
                                              </NavLink>
                                            ) : (
                                              <ListItem
                                                disablePadding
                                                className={`${category.lines.length > lineIdx + 1 && "border__list "} is__relative menu__line__list`}
                                                onMouseEnter={(e) => {
                                                  setIsInspectionDetailsHovered(true);
                                                  setIsHoveredInspectionDetailsLineUuid(line.uuid);
                                                }}
                                                onMouseLeave={() => setIsInspectionDetailsHovered(false)}
                                              >
                                                <SvgIcon className="curve" viewBox="">
                                                  {category.lines.length > lineIdx + 1 ? curve : curveEnd}
                                                </SvgIcon>
                                                <ListItemButton disableRipple>
                                                  {line?.showLineEmpty && duplicateCategoryIdx == categoryIdx ? (
                                                    <>
                                                      {lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && (
                                                        <Skeleton variant="text" sx={{ width: "100%", height: "2.5rem", display: "block", marginLeft: "14px" }} />
                                                      )}
                                                      <div
                                                        className={lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && "animation-line"}
                                                        style={{
                                                          animation: lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && "fadeIn 0.5s ease,increaseHeight 0.5s forwards",
                                                        }}
                                                      >
                                                        {" "}
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <div
                                                      className={`list__content line__list__padding ${duplicateCategoryClassCondition ? "duplicated_line" : ""}`}
                                                      style={{
                                                        animation: lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && "fadeIn 0.5s ease,increaseHeight 0.5s forwards",
                                                      }}
                                                    >
                                                      <span>{line.prompt}</span>{" "}
                                                      <span >
                                                        <CheckCircleIcon
                                                          className="done_icon"
                                                          style={{
                                                            visibility:
                                                              template?.is_narrative_template === 1
                                                                ? (line?.is_completed ? "visible" : "hidden")
                                                                : ((isHoveredLineUuid !== line.uuid || !isHovered) && checkLineComplete(line, "normal"))
                                                                  ? "visible"
                                                                  : "hidden",
                                                          }}
                                                        />
                                                        {isInspectionDetailsHovered && isHoveredInspectionDetailsLineUuid === line.uuid && (
                                                          <>
                                                            {duplicateLineIconClicked ? (
                                                              <span
                                                                className="DuplicateIcon"
                                                                onClick={(e) => {
                                                                  e.preventDefault();
                                                                  e.stopPropagation();
                                                                }}
                                                              >
                                                                <GrDuplicate />
                                                              </span>
                                                            ) : (
                                                              <span
                                                                className="DuplicateIcon"
                                                                onClick={(e) => {
                                                                  handleDuplicateLine(template?.template_id, category?.uuid, line, e, lineIdx, categoryIdx);
                                                                }}
                                                              >
                                                                <GrDuplicate />
                                                              </span>
                                                            )}
                                                            <span
                                                              className="DeleteIcon"
                                                              onClick={(e) => {
                                                                handleLineDelete(line, lineIdx, category, template);
                                                                e.preventDefault();
                                                              }}
                                                            >
                                                              <DeleteIcon />
                                                            </span>
                                                          </>
                                                        )}
                                                      </span>
                                                    </div>
                                                  )}
                                                  {/* <ListItemText primary={line.prompt} /> */}
                                                </ListItemButton>
                                              </ListItem>
                                            )
                                          ) : (
                                            <>
                                              {lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && (
                                                <Skeleton variant="text" sx={{ width: "100%", height: "2.5rem", display: "block", marginLeft: "14px" }} />
                                              )}
                                              <div
                                                className={activeLineIdx === lineIdx && "animation-DeleteCategory"}
                                                style={{ animation: activeLineIdx === lineIdx && "fadeIn 0.5s ease, decreseLineHeight 0.5s forwards" }}
                                              >
                                                {" "}
                                              </div>
                                            </>
                                          )
                                        ) : (
                                          <>
                                            {lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && (
                                              <Skeleton variant="text" sx={{ width: "100%", height: "2.5rem", display: "block", marginLeft: "14px" }} />
                                            )}
                                            <div
                                              className={activeLineIdx === lineIdx && "animation-DeleteCategory"}
                                              style={{ animation: activeLineIdx === lineIdx && "fadeIn 0.5s ease, decreseLineHeight 0.5s forwards" }}
                                            >
                                              {" "}
                                            </div>
                                          </>
                                        );
                                      })}
                                      {category?.is_inspection_details == 2
                                        ? ""
                                        : active == category?.uuid && (
                                          <div onClick={() => handleAddLine(categoryData?.is_inspection_details, categoryData?.parent_uuid)} className="sidemenu_add_category_button">
                                            <AddCircleIcon /> <span style={{ marginLeft: "4px" }}>New Line</span>{" "}
                                          </div>
                                        )}
                                    </List> : null}
                                  </div>
                                ) : (
                                  <div
                                    className={activeDeleteCategoryIdx === categoryIdx && "animation-DeleteCategory"}
                                    style={{ animation: activeDeleteCategoryIdx === categoryIdx && "fadeIn 0.5s ease, decreseLineHeight 0.5s forwards" }}
                                  >
                                    {" "}
                                  </div>
                                )
                              )}
                              <div onClick={() => handleAddCategory(template?.template_uuid, template?.template_id)} className="sidemenu_add_category_button">
                                <AddCircleIcon /> <span style={{ marginLeft: "4px" }}>New Category</span>{" "}
                              </div>
                            </div>
                            {menuData.length > templateIdx + 1 && <Divider style={{ marginBottom: "15px", marginTop: "10px" }} />}
                          </div>
                        ) : template?.is_pdf_template === 1 ? (
                          <div key={templateIdx}>
                            <List key={templateIdx} disablePadding className="menu__items">
                              <NavLink
                                className={`navlink ${activeTemplate === template.template_id ? "active_template" : ""}`}
                                to={{ pathname: `/inspection` }}
                                state={{ template, template_id: template?.template_id, tempIndex: templateIdx, isPDF: 1 }}
                                style={{ textDecoration: "none" }}
                                onClick={() => clearEditStatuses()}
                                id={`template_${templateIdx + 1}`}
                              >
                                <ListItem disablePadding className="list__item" onClick={() => activeTemplateHandle(template.template_id)}>
                                  <ListItemButton disableRipple>
                                    <ListItemIcon>{template?.is_pdf_template !== 1 ? <AssignmentOutlinedIcon /> : <PictureAsPdfOutlinedIcon />}</ListItemIcon>
                                    <ListItemText className="list__text" primary={template.name} />
                                  </ListItemButton>
                                </ListItem>
                              </NavLink>
                            </List>
                            <div className="menu__categories__section">
                              {template.pdf_categories?.map((pdfcategory, pdfcategoryIdx) =>
                                pdfcategory.is_deleted !== 1 ? (
                                  <div key={pdfcategoryIdx} style={{ marginBottom: "4px" }}>
                                    {pdfcategory?.is_inspection_details === 1 && getNonNarrativeTemplatesGuid(inspectionResponse?.inspectiontemplates)?.[0] !== template.template_guid ? (
                                      ""
                                    ) : (
                                      <List key={pdfcategoryIdx} disablePadding>
                                        <NavLink
                                          className={`navlink ${active === pdfcategory.uuid && activeLineCondition ? "active_category" : ""}`}
                                          to={{ pathname: `/inspection/${pdfcategory.prompt !== null && pdfcategory?.prompt !== "" ? encodeURIComponent(pdfcategory.prompt) : "Untitled"}` }}
                                          state={{
                                            pdfcategory,
                                            template_id: template?.template_id,
                                            category_id: pdfcategory.id,
                                            category_uuid: pdfcategory.uuid,
                                            isPDF: 1,
                                            template_guid: template.template_guid,
                                            pdfcategoryType: pdfcategory?.type,
                                          }}
                                          style={{ textDecoration: "none" }}
                                          onClick={() => clearEditStatuses()}
                                          id={`category_${pdfcategoryIdx}`}
                                        >
                                          <ListItem disablePadding onClick={() => activeHandle(pdfcategory.uuid)} className="categories__list">
                                            <ListItemButton disableRipple>
                                              {pdfcategory?.type != 3 ? (
                                                <div className="list__content">
                                                  <span>{pdfcategory?.prompt !== null ? pdfcategory.prompt : "Untitled"}</span>
                                                </div>
                                              ) : (
                                                <div className="how_to_use_this_form__content">
                                                  <span>{pdfcategory?.prompt !== null ? pdfcategory.prompt : "Untitled"}</span>
                                                </div>
                                              )}
                                            </ListItemButton>
                                          </ListItem>
                                        </NavLink>
                                      </List>
                                    )}
                                  </div>
                                ) : (
                                  ""
                                )
                              )}
                            </div>
                            {menuData.length > templateIdx + 1 && <Divider style={{ marginBottom: "15px", marginTop: "10px" }} />}
                          </div>
                        ) : (
                          // narrative template sidemenu Starts
                          <div key={templateIdx}>
                            <List key={templateIdx} disablePadding className="menu__items">
                              <NavLink
                                className={`navlink ${activeTemplate === template.template_id ? "active_template" : ""}`}
                                to={{ pathname: `/inspection` }}
                                state={{ template, template_id: template.template_id, tempIndex: templateIdx, isNarrative: true }}
                                style={{ textDecoration: "none" }}
                                onClick={() => clearEditStatuses()}
                                id={`template_${templateIdx + 1}`}
                              >
                                <ListItem disablePadding className="list__item" onClick={() => activeTemplateHandle(template.template_id)}>
                                  <ListItemButton disableRipple>
                                    <ListItemIcon>
                                      <AssignmentOutlinedIcon />
                                    </ListItemIcon>
                                    <ListItemText className="list__text" primary={template?.name} />
                                  </ListItemButton>
                                </ListItem>
                              </NavLink>
                            </List>
                            <div className="menu__categories__section">
                              {template.categories?.map((category, categoryIdx) =>
                                category.is_deleted !== 1 ? (
                                  <div key={categoryIdx} style={{ marginBottom: "4px" }}>
                                    {category?.is_inspection_details === 1 && getNonNarrativeTemplatesGuid(inspectionResponse?.inspectiontemplates)?.[0] !== template.template_guid ? (
                                      ""
                                    ) : (
                                      <>
                                        <List
                                          key={categoryIdx}
                                          disablePadding
                                          className={duplicatedCategoryTemplateIdx === templateIdx && tempDuplicateCategoryIdx === categoryIdx && !category?.showEmpty && "duplicated_category"}
                                          sx={{
                                            animation:
                                              duplicatedCategoryTemplateIdx === templateIdx &&
                                              categoryHighlighted &&
                                              tempDuplicateCategoryIdx === categoryIdx &&
                                              category?.showEmpty &&
                                              "fadeIn 0.5s ease,increaseHeight 0.5s forwards",
                                          }}
                                        >
                                          <NavLink
                                            className={`navlink ${active === category.uuid && activeLineCondition ? "active_category" : ""}`}
                                            to={{ pathname: `/inspection/${category.prompt !== null && category?.prompt !== "" ? encodeURIComponent(category.prompt) : "Untitled"}` }}
                                            state={{ category, template_id: template.template_id, category_id: category.id, category_uuid: category.uuid, isNarrative: true, parent_uuid: category?.parent_uuid }}
                                            style={{ textDecoration: "none" }}
                                            onClick={() => {
                                              clearEditStatuses();
                                              setActiveDeleteAndDuplicateCategory(category);
                                              setActiveDeleteAndDuplicateTemplate(template);
                                            }}
                                            id={`category_${categoryIdx}`}
                                            onMouseEnter={() => {
                                              if (category.is_inspection_details !== 2 && !category?.showEmpty) {
                                                setIsCategoryHovered(true);
                                                setIsHoveredCategoryUuid(category?.uuid);
                                              }
                                            }}
                                            onMouseLeave={() => {
                                              if (category.is_inspection_details !== 2 && !category?.showEmpty) {
                                                setIsCategoryHovered(false);
                                              }
                                            }}
                                          >
                                            <ListItem disablePadding className="categories__list">
                                              <ListItemButton disableRipple>
                                                {duplicatedCategoryTemplateIdx === templateIdx && categoryHighlighted && tempDuplicateCategoryIdx === categoryIdx ? (
                                                  <Skeleton variant="text" sx={{ width: "100%", paddingBottom: "1.5rem", marginBottom: "1.5rem", marginTop: "-0.75rem" }} />
                                                ) : (
                                                  <>
                                                    <div className="list__content" onClick={() => activeHandle(category.uuid)}>
                                                      <Grid container>
                                                        <Grid
                                                          item
                                                          xs={1}
                                                          justifyContent={"center"}
                                                          display={"flex"}
                                                          alignItems={"center"}
                                                          flexDirection={"row"}
                                                        >
                                                          <>
                                                            {assosiatedCategoryColor(category, assignColorList)?.length <= 2 &&
                                                              assosiatedCategoryColor(category, assignColorList)?.map((color, index) => (
                                                                <div
                                                                  key={index}
                                                                  style={{
                                                                    position: "absolute",
                                                                    width: "15px",
                                                                    height: "15px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: color,
                                                                    border: "2px solid #FFFFFF",
                                                                    top: index === 0 ? assosiatedCategoryColor(category, assignColorList)?.length <= 1 ? "3px" : "-4px" : "10px",
                                                                    left: index === 0 ? assosiatedCategoryColor(category, assignColorList)?.length <= 1 ? "6px" : "6px" : "6px",
                                                                  }}
                                                                ></div>
                                                              ))}
                                                            {assosiatedCategoryColor(category, assignColorList)?.length >= 3 &&
                                                              assosiatedCategoryColor(category, assignColorList)
                                                                ?.slice(0, 3)
                                                                ?.map((color, index) => (
                                                                  <div
                                                                    key={index}
                                                                    style={{
                                                                      position: "absolute",
                                                                      width: "15px",
                                                                      height: "15px",
                                                                      borderRadius: "50%",
                                                                      backgroundColor: color,
                                                                      border: "2px solid #FFFFFF",
                                                                      top: index === 0 ? "-4px" : index === 1 ? "11px" : "3px",
                                                                      left: index === 0 ? "4px" : index === 1 ? "4px" : "12px",
                                                                    }}
                                                                  ></div>
                                                                ))}
                                                            {assosiatedCategoryColor(category, assignColorList)?.length > 3 && (
                                                              <div
                                                                style={{
                                                                  position: "absolute",
                                                                  top: "-13px",
                                                                  left: "18px",
                                                                  fontSize: "14px",
                                                                  fontWeight: "bold",
                                                                  color: "#000",
                                                                }}
                                                              >
                                                                +
                                                              </div>
                                                            )}
                                                          </>
                                                        </Grid>
                                                        <Grid item xs={10}>
                                                          <span
                                                            className={
                                                              duplicatedCategoryTemplateIdx === templateIdx &&
                                                              categoryHighlighted &&
                                                              tempDuplicateCategoryIdx === categoryIdx &&
                                                              !category?.showEmpty &&
                                                              "pulse-once"
                                                            }
                                                            style={{ display: "block", width: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}
                                                            title={category.prompt !== null && category?.prompt !== "" ? category.prompt : "Untitled"} // Tooltip for full text
                                                          >
                                                            {category.prompt !== null && category?.prompt !== "" ? category.prompt : category?.showEmpty ? "" : "Untitled"}
                                                          </span>
                                                        </Grid>
                                                        <Grid item xs={1} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
                                                          {category.is_inspection_details === 1 ? (
                                                            template?.is_narrative_template === 1 ? (
                                                              <span>
                                                                {categoryPercentCalculateNarrative(category)?.lineComplete}/{categoryPercentCalculateNarrative(category)?.totalLines}
                                                              </span>
                                                            ) : (
                                                              <span>
                                                                {categoryPercentCalculate(category)?.lineComplete}/{categoryPercentCalculate(category)?.totalLines}
                                                              </span>
                                                            )
                                                          ) : (
                                                            (isHoveredCategoryUuid !== category?.uuid || !isCategoryHovered) && (
                                                              <>
                                                                {category?.showEmpty ? (
                                                                  ""
                                                                ) : (
                                                                  template?.is_narrative_template === 1 ? (
                                                                    <span>
                                                                      {categoryPercentCalculateNarrative(category)?.lineComplete}/{categoryPercentCalculateNarrative(category)?.totalLines}
                                                                    </span>
                                                                  ) : (
                                                                    <span>
                                                                      {categoryPercentCalculate(category)?.lineComplete}/{categoryPercentCalculate(category)?.totalLines}
                                                                    </span>
                                                                  )
                                                                )}
                                                              </>
                                                            )
                                                          )}
                                                          {category.is_inspection_details !== 1
                                                            ? isCategoryHovered &&
                                                            isHoveredCategoryUuid === category?.uuid && (
                                                              <>
                                                                {duplicateLineIconClicked ? (
                                                                  <span
                                                                    className="DuplicateIcon"
                                                                    onClick={(e) => {
                                                                      e.preventDefault();
                                                                      e.stopPropagation();
                                                                    }}
                                                                  >
                                                                    <GrDuplicate />
                                                                  </span>
                                                                ) : (
                                                                  <span
                                                                    className="DuplicateIcon"
                                                                    onClick={(e) => {
                                                                      handleDuplicateCategory(template?.template_id, category, e, categoryIdx, templateIdx);
                                                                    }}
                                                                  >
                                                                    <GrDuplicate />
                                                                  </span>
                                                                )}
                                                                <span
                                                                  className="DeleteIcon"
                                                                  onClick={(e) => {
                                                                    handleCategoryDelete(category, e, categoryIdx);
                                                                    e.preventDefault();
                                                                  }}
                                                                >
                                                                  <DeleteIcon />
                                                                </span>
                                                              </>
                                                            )
                                                            : ""}
                                                        </Grid>
                                                      </Grid>
                                                    </div>

                                                  </>
                                                )}
                                              </ListItemButton>
                                            </ListItem>
                                          </NavLink>
                                        </List>
                                      </>
                                    )}
                                    <List disablePadding className={`${active === category.uuid ? "menu__line__section ul_active" : "menu__line__section"}`}>
                                      {category.lines?.map((line, lineIdx) => {
                                        let duplicateCategoryClassCondition = duplicateCategoryIdx == categoryIdx && tempDuplicateLineIdx === lineIdx && !line?.showLineEmpty;
                                        return line.is_deleted !== 1 ? (
                                          active === category.uuid ? (
                                            category.is_inspection_details !== 1 ? (
                                              <NavLink
                                                className={`navlink ${activeLine === line.uuid || storeData?.activeLineUuid === line.uuid ? "active_line" : ""}`}
                                                to={{
                                                  pathname: `/inspection/${category.prompt !== null && category?.prompt !== "" ? encodeURIComponent(category.prompt) : "Untitled"}/${line.prompt !== null && line?.prompt !== "" ? encodeURIComponent(line.prompt) : "Untitled"
                                                    }`,
                                                }}
                                                state={{
                                                  line,
                                                  template_id: template.template_id,
                                                  category_id: category.id,
                                                  category_uuid: category.uuid,
                                                  line_uuid: line.uuid,
                                                  template_guid: template.template_guid,
                                                  isNarrative: true,
                                                  parent_uuid: category?.parent_uuid
                                                }}
                                                style={{ textDecoration: "none" }}
                                                onClick={() => {
                                                  categorylineRelation(template, category, line);
                                                  clearEditStatuses();
                                                  setActiveDeleteAndDuplicateTemplate(template);
                                                  setActiveDeleteAndDuplicateCategory(category);
                                                }}
                                                onMouseEnter={(e) => {
                                                  !line?.showLineEmpty && setIsHovered(true);
                                                  setIsHoveredLineUuid(line.uuid);
                                                }}
                                                onMouseLeave={() => {
                                                  !line?.showLineEmpty && setIsHovered(false);
                                                }}
                                              >
                                                <ListItem
                                                  disablePadding
                                                  className={`${category.lines.length > lineIdx + 1 && "border__list "} is__relative menu__line__list`}
                                                  onClick={() => activeHandleLine(line.uuid)}
                                                >
                                                  <SvgIcon className="curve" viewBox="">
                                                    {category.lines.length > lineIdx + 1 ? curve : curveEnd}
                                                  </SvgIcon>
                                                  {!deleteCategoryModal && (
                                                    <ListItemButton disableRipple>
                                                      {line?.showLineEmpty && duplicateCategoryIdx == categoryIdx && lineHighlighted ? (
                                                        <>
                                                          {lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && (
                                                            <Skeleton variant="text" sx={{ width: "100%", height: "2.5rem", display: "block", marginLeft: "14px" }} />
                                                          )}
                                                          <div
                                                            className={
                                                              duplicateCategoryIdx == categoryIdx && lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && "animation-line"
                                                            }
                                                            style={{
                                                              animation:
                                                                duplicateCategoryIdx == categoryIdx &&
                                                                lineHighlighted &&
                                                                tempDuplicateLineIdx === lineIdx &&
                                                                line?.showLineEmpty &&
                                                                "fadeIn 0.5s ease,increaseHeight 0.5s forwards",
                                                            }}
                                                          >
                                                            {" "}
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <div
                                                          className={`list__content line__list__padding ${duplicateCategoryClassCondition ? "duplicated_line" : ""}`}
                                                          style={{
                                                            padding: assosiatedLineColor(line?.inspector_flagging_guids, assignColorList)?.length > 0 ? "5px 0px 5px 0px" : "10px 0px 10px 0px",
                                                            animation: lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && "fadeIn 0.5s ease,increaseHeight 0.5s forwards",
                                                          }}
                                                        >
                                                          <Grid container display={"flex"} alignItems={"center"}>
                                                            <Grid
                                                              item
                                                              xs={1}
                                                              justifyContent={"flex-end"}
                                                              display={"flex"}
                                                              alignItems={"center"}
                                                              flexDirection={assosiatedLineColor(line?.inspector_flagging_guids, assignColorList)?.length === 2 ? "column" : "row"}
                                                            >
                                                              <>
                                                                {line?.inspector_flagging_guids?.length === 1 && (
                                                                  <div style={{ position: "relative", width: "22px", height: "33px" }}>
                                                                    {assosiatedLineColor(line?.inspector_flagging_guids, assignColorList).map((color, index) => {
                                                                      const positions = [{ top: "10px", left: "0px" }];
                                                                      return <div key={index} style={{ position: "absolute", width: "15px", height: "15px", borderRadius: "50%", backgroundColor: color, ...positions[index], border: "2px solid #ffffff" }}></div>;
                                                                    })}
                                                                  </div>
                                                                )}
                                                                {line?.inspector_flagging_guids?.length === 2 && (
                                                                  <div style={{ position: "relative", width: "22px", height: "33px" }}>
                                                                    {assosiatedLineColor(line?.inspector_flagging_guids, assignColorList).map((color, index) => {
                                                                      const positions = [
                                                                        { top: "0px", left: "2px" },
                                                                        { top: "15px", left: "2px" },
                                                                      ];
                                                                      return <div key={index} style={{ position: "absolute", width: "15px", height: "15px", borderRadius: "50%", backgroundColor: color, ...positions[index], border: "2px solid #ffffff" }}></div>;
                                                                    })}
                                                                  </div>
                                                                )}
                                                                {line?.inspector_flagging_guids?.length >= 3 && (
                                                                  <div style={{ position: "relative", width: "22px", height: "33px" }}>
                                                                    {assosiatedLineColor(line?.inspector_flagging_guids, assignColorList)
                                                                      ?.slice(0, 3)
                                                                      ?.map((color, index) => {
                                                                        const positions = [
                                                                          { top: "2px", left: "0px" },
                                                                          { top: "16px", left: "0px" },
                                                                          { top: "8px", left: "8px" },
                                                                        ];
                                                                        return <div key={index} style={{ position: "absolute", width: "15px", height: "15px", borderRadius: "50%", backgroundColor: color, ...positions[index], border: "2px solid #ffffff" }}></div>;
                                                                      })}
                                                                    {line?.inspector_flagging_guids?.length > 3 && <div style={{ position: "absolute", top: "-8px", left: "16px", fontSize: "16px", fontWeight: "bold", color: "#3b3b3b", }}>+</div>}
                                                                  </div>
                                                                )}
                                                              </>
                                                            </Grid>
                                                            <Grid item xs={8} display="flex" alignItems="center" justifyContent="flex-start">
                                                              <span
                                                                style={{
                                                                  width: "100%",
                                                                  whiteSpace: "nowrap",
                                                                  overflow: "hidden",
                                                                  textOverflow: "ellipsis",
                                                                  display: "block",
                                                                  padding: "2px 0px 2px 5px",
                                                                }}
                                                                className={lineHighlighted && tempDuplicateLineIdx === lineIdx && !line?.showLineEmpty ? "pulse-once" : ""}
                                                                title={line.prompt !== null && line?.prompt !== "" ? line.prompt : "Untitled"} // Tooltip for full text
                                                              >
                                                                {line.prompt !== null && line?.prompt !== "" ? line.prompt : "Untitled"}
                                                              </span>
                                                            </Grid>
                                                            <Grid item={3} display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
                                                              <span style={{ display: "flex" }}>
                                                                <CheckCircleIcon
                                                                  className="done_icon"
                                                                  style={{
                                                                    visibility:
                                                                      template?.is_narrative_template === 1
                                                                        ? (line?.is_completed ? "visible" : "hidden")
                                                                        : ((isHoveredLineUuid !== line.uuid || !isHovered) && checkLineComplete(line, "normal"))
                                                                          ? "visible"
                                                                          : "hidden",
                                                                  }}
                                                                />
                                                                {isHovered && isHoveredLineUuid === line.uuid && (
                                                                  <>
                                                                    {duplicateLineIconClicked ? (
                                                                      <span
                                                                        className="DuplicateIcon"
                                                                        onClick={(e) => {
                                                                          e.preventDefault();
                                                                          e.stopPropagation();
                                                                        }}
                                                                      >
                                                                        <GrDuplicate />
                                                                      </span>
                                                                    ) : (
                                                                      <span
                                                                        className="DuplicateIcon"
                                                                        onClick={(e) => {
                                                                          handleDuplicateLine(template?.template_id, category?.uuid, line, e, lineIdx, categoryIdx);
                                                                          e.preventDefault();
                                                                        }}
                                                                      >
                                                                        <GrDuplicate />
                                                                      </span>
                                                                    )}
                                                                    <span
                                                                      style={{ display: "flex" }}
                                                                      className="DeleteIcon"
                                                                      onClick={(e) => {
                                                                        handleLineDelete(line, lineIdx, category, template);
                                                                        e.preventDefault();
                                                                      }}
                                                                    >
                                                                      <DeleteIcon />
                                                                    </span>
                                                                  </>
                                                                )}
                                                              </span>
                                                            </Grid>
                                                          </Grid>
                                                        </div>
                                                      )}
                                                    </ListItemButton>
                                                  )}
                                                </ListItem>
                                              </NavLink>
                                            ) : (
                                              <ListItem
                                                disablePadding
                                                className={`${category.lines.length > lineIdx + 1 && "border__list "} is__relative menu__line__list`}
                                                onMouseEnter={(e) => {
                                                  setIsInspectionDetailsHovered(true);
                                                  setIsHoveredInspectionDetailsLineUuid(line.uuid);
                                                }}
                                                onMouseLeave={() => setIsInspectionDetailsHovered(false)}
                                              >
                                                <SvgIcon className="curve" viewBox="">
                                                  {category.lines.length > lineIdx + 1 ? curve : curveEnd}
                                                </SvgIcon>
                                                <ListItemButton disableRipple>
                                                  {line?.showLineEmpty && duplicateCategoryIdx == categoryIdx ? (
                                                    <>
                                                      {lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && (
                                                        <Skeleton variant="text" sx={{ width: "100%", height: "2.5rem", display: "block", marginLeft: "14px" }} />
                                                      )}
                                                      <div
                                                        className={lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && "animation-line"}
                                                        style={{
                                                          animation: lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && "fadeIn 0.5s ease,increaseHeight 0.5s forwards",
                                                        }}
                                                      >
                                                        {" "}
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <div
                                                      className={`list__content line__list__padding ${duplicateCategoryClassCondition ? "duplicated_line" : ""}`}
                                                      style={{
                                                        animation: lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && "fadeIn 0.5s ease,increaseHeight 0.5s forwards",
                                                      }}
                                                    >
                                                      <span>{line.prompt}</span>{" "}
                                                      <span >
                                                        <CheckCircleIcon
                                                          className="done_icon"
                                                          style={{
                                                            visibility:
                                                              template?.is_narrative_template === 1
                                                                ? (line?.is_completed ? "visible" : "hidden")
                                                                : ((isHoveredLineUuid !== line.uuid || !isHovered) && checkLineComplete(line, "normal"))
                                                                  ? "visible"
                                                                  : "hidden",
                                                          }}
                                                        />
                                                        {isInspectionDetailsHovered && isHoveredInspectionDetailsLineUuid === line.uuid && (
                                                          <>
                                                            <span
                                                              className="DeleteIcon"
                                                              onClick={(e) => {
                                                                handleLineDelete(line, lineIdx, category, template);
                                                                e.preventDefault();
                                                              }}
                                                            >
                                                              <DeleteIcon />
                                                            </span>
                                                          </>
                                                        )}
                                                      </span>
                                                    </div>
                                                  )}
                                                </ListItemButton>
                                              </ListItem>
                                            )
                                          ) : (
                                            <>
                                              {lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && (
                                                <Skeleton variant="text" sx={{ width: "100%", height: "2.5rem", display: "block", marginLeft: "14px" }} />
                                              )}
                                              <div
                                                className={activeLineIdx === lineIdx && "animation-DeleteCategory"}
                                                style={{ animation: activeLineIdx === lineIdx && "fadeIn 0.5s ease, decreseLineHeight 0.5s forwards" }}
                                              >
                                                {" "}
                                              </div>
                                            </>
                                          )
                                        ) : (
                                          <>
                                            {lineHighlighted && tempDuplicateLineIdx === lineIdx && line?.showLineEmpty && (
                                              <Skeleton variant="text" sx={{ width: "100%", height: "2.5rem", display: "block", marginLeft: "14px" }} />
                                            )}
                                            <div
                                              className={activeLineIdx === lineIdx && "animation-DeleteCategory"}
                                              style={{ animation: activeLineIdx === lineIdx && "fadeIn 0.5s ease, decreseLineHeight 0.5s forwards" }}
                                            >
                                              {" "}
                                            </div>
                                          </>
                                        );
                                      })}
                                      {category?.is_inspection_details == 2
                                        ? ""
                                        : active == category?.uuid && (
                                          <div onClick={() => handleAddLine(categoryData?.is_inspection_details, categoryData?.parent_uuid)} className="sidemenu_add_category_button">
                                            <AddCircleIcon /> <span style={{ marginLeft: "4px" }}>New Line</span>{" "}
                                          </div>
                                        )}
                                    </List>
                                  </div>
                                ) : (
                                  <div
                                    className={activeDeleteCategoryIdx === categoryIdx && "animation-DeleteCategory"}
                                    style={{ animation: activeDeleteCategoryIdx === categoryIdx && "fadeIn 0.5s ease, decreseLineHeight 0.5s forwards" }}
                                  >
                                    {" "}
                                  </div>
                                )
                              )}
                              <div onClick={() => handleAddCategory(template?.template_uuid, template?.template_id)} className="sidemenu_add_category_button">
                                <AddCircleIcon /> <span style={{ marginLeft: "4px" }}>New Category</span>{" "}
                              </div>
                            </div>
                            {menuData.length > templateIdx + 1 && <Divider style={{ marginBottom: "15px", marginTop: "10px" }} />}
                          </div>
                        )
                      // narrative template sidemenu ends
                    )}
                    {/* <PdfSideMenu/>   */}
                  </>
                )}
              </Box>
            </div>
            {showStaticBackground || staticBG ? (
              ""
            ) : sessionStorage.getItem("AC") !== null && sessionStorage.getItem("AC") !== undefined && Base64.decode(sessionStorage.getItem("AC")) === "Palmtech" ? (
              <div className="portal__link">
                <Typography>
                  <a href={PORTAL_URL} target="_blank">
                    Go to portal <CallMissedOutgoingIcon />
                  </a>{" "}
                </Typography>
              </div>
            ) : (
              ""
            )}
          </div>
        </Grid>
        <div className="sidemenu__footer">
          {showStaticBackground || staticBG ? (
            <div>
              <Avatar sx={{ bgcolor: "#BEBEBE" }}></Avatar>
              <div className="footer_name">
                <Typography>------ ----</Typography>
                <Typography>----------------</Typography>
              </div>
            </div>
          ) : (
            <div>
              <Avatar sx={{ bgcolor: "#BEBEBE" }}>{sessionStorage.getItem("user_displayname") !== "" ? sessionStorage.getItem("user_displayname")?.charAt(0) : "A"}</Avatar>
              <div className="footer_name">
                <Typography>{sessionStorage.getItem("user_displayname")}</Typography>
                <Typography>{sessionStorage.getItem("user_email")}</Typography>
              </div>
            </div>
          )}
          {/* <LogoutIcon/> */}
        </div>
      </Grid >
      <DeleteConfirmationDialog
        open={deleteLineModal}
        handleClose={handleCloseDeleteAlert}
        title={"Delete line"}
        contentText={`Are you sure you want to delete the line ${activeDeleteLine?.prompt}?`}
        cancelBtnTitle={"Cancel"}
        cancelBtnAction={handleCloseDeleteAlert}
        submitBtnTitle={"Delete"}
        submitBtnAction={handleConfirmDeleteLine}
      />
      <DeleteConfirmationDialog
        open={deleteCategoryModal}
        handleClose={handleCloseCategoryDeleteAlert}
        title={"Delete category"}
        contentText={`Are you sure you want to delete the category ${activeDeleteAndDuplicateCategory?.prompt}?`}
        cancelBtnTitle={"Cancel"}
        cancelBtnAction={handleCloseCategoryDeleteAlert}
        submitBtnTitle={"Delete"}
        submitBtnAction={handleConfirmDeleteCategory}
      />
    </>
  );
};

export default SideMenu;
